import apiRequestType from "../apiRequestType";
import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";

const getAllPublishedByMeClassnames = (
  Condition,
  Status,
  classtype,
  filters,
  locale,
  pageNum,
  pageSize
) => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.DISTRIBUTE.GET_ALL_PUBLISHED_BY_ME(
      Condition,
      Status,
      classtype,
      filters,
      locale,
      pageNum,
      pageSize
    )
  );
};

export default getAllPublishedByMeClassnames;
